import { Domain } from '@repo/domain';
export class GoogleGeocodeRepository {
    config;
    constructor(config) {
        this.config = config;
    }
    capabilities = {
        [Domain.AddressPrediction]: async () => {
            return (GoogleGeocodeRepository.addressPredictionRepoPromise ??=
                import('./repositories/AddressPredictionRepository').then((module) => {
                    return new module.AddressPredictionRepository(this.config);
                }));
        },
        [Domain.ForwardGeocodedAddress]: async () => {
            return (GoogleGeocodeRepository.forwardGeocodedAddressRepoPromise ??=
                import('./repositories/ForwardGeocodedAddressRepository').then((module) => {
                    return new module.ForwardGeocodedAddressRepository(this.config);
                }));
        },
        [Domain.ReverseGeocodedAddress]: async () => {
            return (GoogleGeocodeRepository.reverseGeocodedAddressRepoPromise ??=
                import('./repositories/ReverseGeocodedAddressRepository').then((module) => {
                    return new module.ReverseGeocodedAddressRepository(this.config);
                }));
        },
    };
    static addressPredictionRepoPromise;
    static forwardGeocodedAddressRepoPromise;
    static reverseGeocodedAddressRepoPromise;
}
